import { BadgeBox, Pill } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Badge(props) {
  var children = props.children,
    value = props.value,
    _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'primary' : _props$appearance,
    _props$dot = props.dot,
    dot = _props$dot === void 0 ? false : _props$dot,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size;
  return /*#__PURE__*/jsxs(BadgeBox, {
    children: [children, /*#__PURE__*/jsx(Pill, {
      $adjustPosition: Boolean(children),
      $appearance: appearance,
      $dot: dot,
      $size: size,
      children: value
    })]
  });
}

export { Badge };
